import { render, staticRenderFns } from "./ReviewYandexModal.vue?vue&type=template&id=4ff3f957&"
import script from "./ReviewYandexModal.vue?vue&type=script&lang=js&"
export * from "./ReviewYandexModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports